import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {composeEventHandlers} from '../../utils/helpers';

import './styles.sass';

class ConfirmDialogComponent extends Component {
  constructor(props) {
    super(props);
    this.isMobile = props.controller.isMobile;
  }

  close = () => {
    this.props.controller.closeDialog();
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.controller.closeDialog();
  };

  render() {
    const {
      title,
      message,
      cancelText,
      cancelDataQaId,
      confirmText,
      confirmDataQaId,
      onConfirm,
      onCancel,
    } = this.props;

    return (
      <div className="confirmDialog__container">
        <h1>{title}</h1>
        <form onSubmit={composeEventHandlers(this.onSubmit, onConfirm)}>
          <p>{message}</p>
          <div className="editContact__buttons" style={{paddingTop: '5px', textAlign: 'center'}}>
            <button
              onClick={composeEventHandlers(this.close, onCancel)}
              className={`secondary-button button-primary-inverse ${this.isMobile && 'small'}`}
              data-qa-id={cancelDataQaId}
              type="button"
            >
              {cancelText || 'Cancel'}
            </button>
            <button
              className={`primary-button button-primary ${this.isMobile && 'small'}`}
              data-qa-id={confirmDataQaId}
              type="submit"
            >
              {confirmText || 'Ok'}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export const ConfirmDialog = inject('controller')(observer(ConfirmDialogComponent));
